<template>
  <div>
    <!-- Fade-in wrapped content if consent is given -->
    <transition name="fade" v-if="hasConsent">
      <div class="consent-slot">
        <slot />
      </div>
    </transition>

    <!-- Fallback if consent not given -->
    <div v-else class="consent-required">
      <p>{{ fallbackMessage }}</p>
      <button type="button" class="btn btn-gold" @click="openConsentBanner">
        {{ fallbackButtonText }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, defineProps } from 'vue'

const props = defineProps({
  requiredConsent: { type: String, required: true },
  fallbackMessage: {
    type: String,
    default: 'To use this feature, please update your preferences in the consent banner.'
  },
  fallbackButtonText: { type: String, default: 'Update Consent' }
})

const consentPrefs = ref(JSON.parse(localStorage.getItem('consent_preferences') || '{}'))

const hasConsent = computed(() => consentPrefs.value[props.requiredConsent] === true)

function handleConsentUpdate(e) {
  if (e.detail) {
    consentPrefs.value = { ...e.detail }
  } else {
    consentPrefs.value = JSON.parse(localStorage.getItem('consent_preferences') || '{}')
  }
}


function openConsentBanner() {
  window.dispatchEvent(new Event('openConsentBanner'))
}

onMounted(() => {
  window.addEventListener('consent-updated', handleConsentUpdate)
})

onBeforeUnmount(() => {
  window.removeEventListener('consent-updated', handleConsentUpdate)
})
</script>

<style scoped>

.consent-required {
  text-align: center;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}

/* Fade-in animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>
